import { render, staticRenderFns } from "./BulletedTextEl.vue?vue&type=template&id=47a578ac&scoped=true&"
import script from "./BulletedTextEl.vue?vue&type=script&lang=ts&"
export * from "./BulletedTextEl.vue?vue&type=script&lang=ts&"
import style0 from "./BulletedTextEl.vue?vue&type=style&index=0&id=47a578ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a578ac",
  null
  
)

export default component.exports